import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { SupportUnreadBadge } from './SupportUnreadBadge'

export type HubIconName = React.ComponentProps<typeof MaterialCommunityIcons>['name']

export function HubCard({
  icon,
  iconColor,
  title,
  subtitle,
  onPress,
  accessibilityLabel,
  unreadCount = 0,
}: {
  icon: HubIconName
  iconColor: string
  title: string
  subtitle: string
  onPress: () => void
  accessibilityLabel: string
  unreadCount?: number
}) {
  return (
    <TouchableOpacity
      onPress={onPress}
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      className="bg-paper border-2 border-olive rounded-xl px-4 py-4 flex-row items-center gap-4"
      style={{ minHeight: 72 }}
    >
      <MaterialCommunityIcons name={icon} size={22} color={iconColor} />
      <View className="flex-1">
        <View className="flex-row items-center gap-2">
          <Text className="font-stencil text-ink text-base uppercase" style={{ flexShrink: 1 }}>{title}</Text>
          <SupportUnreadBadge count={unreadCount} />
        </View>
        <Text className="font-typed text-ink-soft text-xs">{subtitle}</Text>
      </View>
      <Text className="text-ink-soft text-lg">›</Text>
    </TouchableOpacity>
  )
}
